import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { VehicleInsuranceActivityEventHydration } from './vehicle-insurance-activity-event-hydration.dto';

/**
 * A vehicle insurance activity event with hydrated related records.
 */
export class VehicleInsuranceActivityEventDto extends ActivityEventDto {
  hydrated?: VehicleInsuranceActivityEventHydration;
}
